module.exports = __webpack_public_path__ + "static/media/wordmark-dark.99a1e38e.svg";